<template>
  <validation-address :validation_requestable="model">
  </validation-address>
  <!-- <ul v-if="this.model ">
    <li>{{this.model.decoded_type}}</li>
    <li>{{this.model.first_name}} {{this.model.last_name}}</li>
    <li>{{this.model.slieet_line1}} </li>
    <li v-if="this.model.slieet_line2">
      {{this.model.slieet_line2}}
    </li>
    <li>
      {{this.model.zipcode}}
      {{this.model.city}}
    </li>
    <li v-if="this.model.state">
      {{this.model.state}}
    </li>
    <li> {{this.model.decoded_country}}</li>
  </ul> -->
</template>
<script>
  import ValidationAddress from "./Details/ValidationRequestable/Address"
  export default {

    name:"ModelAdress",

    props:["model", "title"],

    components:{
      ValidationAddress
    },

  }

</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// client/components/Demands/ModelAdress.vue